import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=5a228247&scoped=true"
import script from "./Boleto.vue?vue&type=script&lang=js"
export * from "./Boleto.vue?vue&type=script&lang=js"
import style0 from "./Boleto.vue?vue&type=style&index=0&id=5a228247&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a228247",
  null
  
)

export default component.exports